const SUPPORT_PARAM_PREFIX = 't-typ-podpory['
const SUPPORT_PARAM_KEY = 't-typ-podpory[1]'

function resolveSignpostTargetPath(pathname) {
  if (/^\/podnikatelky\/organizace\/[^/]+\/?$/.test(pathname)) {
    return '/podnikatelky/organizace/'
  }

  return pathname
}

function buildSignpostLinkHref(anchor) {
  const termId = Number.parseInt(anchor.dataset.termId || '', 10)
  if (!Number.isInteger(termId) || termId <= 0) {
    return
  }

  const url = new URL(window.location.href)
  url.hash = ''
  const keysToDelete = []

  url.searchParams.forEach((_, key) => {
    if (key.indexOf(SUPPORT_PARAM_PREFIX) === 0) {
      keysToDelete.push(key)
    }
  })

  keysToDelete.forEach((key) => url.searchParams.delete(key))
  url.searchParams.set(SUPPORT_PARAM_KEY, String(termId))

  // Guard against malformed query values carrying a fragment marker.
  Array.from(url.searchParams.keys()).forEach((key) => {
    const value = url.searchParams.get(key)
    if (!value || !value.includes('#')) return
    url.searchParams.set(key, value.split('#')[0])
  })

  const targetPath = resolveSignpostTargetPath(url.pathname)
  anchor.setAttribute('href', `${targetPath}?${url.searchParams.toString()}`)
}

function initPodnikatelkySignpostLinks() {
  const links = document.querySelectorAll('a.js-signpost-link[data-term-id]')

  links.forEach((link) => {
    buildSignpostLinkHref(link)
  })
}

function openSignpostBox(box) {
  const dots = box.querySelector('.js-signpost-dots')
  const listLinks = Array.from(box.querySelectorAll('.signpost__list a'))
  box.classList.add('is-active')
  if (dots) dots.setAttribute('aria-expanded', 'true')
  listLinks.forEach((link) => link.setAttribute('tabindex', '0'))
}

function closeSignpostBox(box) {
  const dots = box.querySelector('.js-signpost-dots')
  const listLinks = Array.from(box.querySelectorAll('.signpost__list a'))
  box.classList.remove('is-active')
  if (dots) dots.setAttribute('aria-expanded', 'false')
  listLinks.forEach((link) => link.setAttribute('tabindex', '-1'))
}

function initSignpostFocusRestore() {
  const STORAGE_KEY = 'signpost-focus-term-id'

  const savedTermId = sessionStorage.getItem(STORAGE_KEY)
  if (savedTermId) {
    sessionStorage.removeItem(STORAGE_KEY)
    const target = document.querySelector(`.signpost__inner.js-signpost-link[data-term-id="${savedTermId}"]`)
    if (target) {
      target.focus()
    }
  }

  document.querySelectorAll('.signpost__inner.js-signpost-link').forEach((link) => {
    link.addEventListener('click', () => {
      sessionStorage.setItem(STORAGE_KEY, link.dataset.termId)
    })
  })
}

function initSignpostDotsTouch() {
  if (!window.matchMedia('(pointer: coarse)').matches) {
    return
  }

  document.querySelectorAll('.js-signpost-dots').forEach((dots) => {
    dots.addEventListener('click', (e) => {
      e.stopPropagation()
      const box = dots.closest('.signpost__box')
      if (!box) return
      box.classList.contains('is-active') ? closeSignpostBox(box) : openSignpostBox(box)
    })
  })

  document.addEventListener('click', () => {
    document.querySelectorAll('.signpost__box.is-active').forEach((box) => {
      closeSignpostBox(box)
    })
  })
}

function initSignpostFilterHighlight() {
  const params = new URLSearchParams(window.location.search)
  const selectedTermIds = new Set()

  params.forEach((value, key) => {
    if (key.startsWith('t-typ-podpory[')) {
      selectedTermIds.add(value)
    }
  })

  if (selectedTermIds.size === 0) return

  document.querySelectorAll('.js-signpost-link[data-term-id]').forEach((link) => {
    if (!selectedTermIds.has(link.dataset.termId)) return

    let inner = null
    if (link.classList.contains('signpost__inner')) {
      inner = link
    } else {
      inner = link.closest('.signpost__box')?.querySelector('.signpost__inner') ?? null
      link.classList.add('is-filtered')
    }

    if (inner) {
      inner.classList.add('is-filtered')
    }
  })
}

function initSignpostDotsDesktop() {
  if (!window.matchMedia('(pointer: fine)').matches) {
    return
  }

  document.querySelectorAll('.js-signpost-dots').forEach((dots) => {
    dots.addEventListener('click', (e) => {
      e.stopPropagation()
      const box = dots.closest('.signpost__box')
      if (!box) return
      box.classList.contains('is-active') ? closeSignpostBox(box) : openSignpostBox(box)
    })
  })

  document.addEventListener('click', () => {
    document.querySelectorAll('.signpost__box.is-active').forEach((box) => {
      closeSignpostBox(box)
    })
  })
}

function initSignpostDotsKeyboard() {
  document.querySelectorAll('.js-signpost-dots').forEach((dots) => {
    const box = dots.closest('.signpost__box')
    if (!box) return

    const listLinks = Array.from(box.querySelectorAll('.signpost__list a'))

    listLinks.forEach((link) => link.setAttribute('tabindex', '-1'))

    dots.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        if (box.classList.contains('is-active')) {
          closeSignpostBox(box)
        } else {
          openSignpostBox(box)
          listLinks[0]?.focus()
        }
      } else if (e.key === 'Escape') {
        closeSignpostBox(box)
      }
    })

    listLinks.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault()
          closeSignpostBox(box)
          dots.focus()
        }

        if (e.key === 'Tab' && !e.shiftKey && index === listLinks.length - 1) {
          closeSignpostBox(box)
        }

        if (e.key === 'Tab' && e.shiftKey && index === 0) {
          closeSignpostBox(box)
        }
      })
    })
  })
}

function initSignpostMenuSmallMobile() {
  if (!window.matchMedia('(pointer: coarse)').matches) return

  document.querySelectorAll('.signpost--menu-small .signpost__box').forEach((box) => {
    const list = box.querySelector('.signpost__list')
    if (!list) return

    const inner = box.querySelector('.signpost__inner')
    if (!inner) return

    const termId = inner.dataset.termId
    const labelText = (inner.querySelector('p')?.innerText || '').trim()

    if (labelText && termId) {
      const titleLi = document.createElement('li')
      titleLi.className = 'signpost__list-title'
      const titleA = document.createElement('a')
      titleA.href = '#'
      titleA.className = 'js-signpost-link'
      titleA.dataset.termId = termId
      titleA.textContent = labelText
      buildSignpostLinkHref(titleA)
      titleLi.appendChild(titleA)
      list.querySelector('ul')?.prepend(titleLi)
    }

    const openMenu = (focusFirst = false) => {
      document.querySelectorAll('.signpost--menu-small .signpost__box.is-active').forEach((b) => {
        closeSignpostBox(b)
      })
      openSignpostBox(box)
      if (focusFirst) {
        const firstLink = list.querySelector('a')
        firstLink?.focus()
      }
    }

    const closeMenu = () => {
      closeSignpostBox(box)
    }

    inner.addEventListener('click', (e) => {
      if (window.innerWidth >= 564) return

      e.preventDefault()
      e.stopPropagation()

      if (box.classList.contains('is-active')) {
        closeMenu()
      } else {
        openMenu(false)
      }
    })

    inner.addEventListener('keydown', (e) => {
      if (window.innerWidth >= 564) return
      if (e.key !== 'Enter' && e.key !== ' ') return

      e.preventDefault()
      e.stopPropagation()

      if (box.classList.contains('is-active')) {
        closeMenu()
        inner.focus()
      } else {
        openMenu(true)
      }
    })

    box.addEventListener('focusout', (e) => {
      if (window.innerWidth >= 564) return
      if (!box.contains(e.relatedTarget)) {
        closeMenu()
      }
    })

    box.addEventListener('keydown', (e) => {
      if (window.innerWidth >= 564) return
      if (e.key === 'Escape') {
        e.preventDefault()
        closeMenu()
        inner.focus()
      }
    })
  })
}

function initSignpostFilterTrigger() {
  const signpostFilterTrigger = document.querySelector('.js-signpost-filter')
  const podnikatelkyFilter = document.querySelector('.js-podnikatelky-filter')
  const filterTermsButton = document.querySelector('.js-filter-terms-button')

  if (!signpostFilterTrigger || !podnikatelkyFilter || !filterTermsButton) {
    return
  }

  const showPodnikatelkyFilter = (event) => {
    event.preventDefault()
    podnikatelkyFilter.classList.remove('d-none')
  }

  signpostFilterTrigger.addEventListener('click', showPodnikatelkyFilter)
  signpostFilterTrigger.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      showPodnikatelkyFilter(event)
    }
  })

  filterTermsButton.addEventListener('click', () => {
    podnikatelkyFilter.classList.add('d-none')
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initPodnikatelkySignpostLinks()
    initSignpostFilterHighlight()
    initSignpostFocusRestore()
    initSignpostDotsTouch()
    initSignpostDotsDesktop()
    initSignpostDotsKeyboard()
    initSignpostMenuSmallMobile()
    initSignpostFilterTrigger()
  })
} else {
  initPodnikatelkySignpostLinks()
  initSignpostFilterHighlight()
  initSignpostDotsTouch()
  initSignpostDotsDesktop()
  initSignpostDotsKeyboard()
  initSignpostMenuSmallMobile()
  initSignpostFilterTrigger()
}
